import React, { useCallback, useState } from 'react';
import { Tag } from '@indeed/ifl-components';
import { TagListContainer, TagListOuterContainer } from './Containers';
import useTagListLayout from './useTagListLayout';
export var TagListExpandedState;
(function (TagListExpandedState) {
    TagListExpandedState["EXPANDED"] = "expanded";
    TagListExpandedState["COLLAPSED"] = "collapsed";
})(TagListExpandedState || (TagListExpandedState = {}));
const TagList = ({ containerSx, outerContainerSx, linesCollapsed, items, initialFirstOverflowIndex, initialContainerHeight = 0, renderOverflowIndicator: OverflowIndicator, sx, ...rest }) => {
    const { refContainer, refOverflow, refItems, hasBeenInitialized, firstOverflowIndex, overflowTop, overflowLeft, containerHeight } = useTagListLayout(typeof linesCollapsed !== 'undefined' && linesCollapsed > 0
        ? { linesCollapsed, initialFirstOverflowIndex, initialContainerHeight }
        : undefined);
    const [expandedState, setExpandedState] = useState(TagListExpandedState.COLLAPSED);
    const onToggleOverflowIndicator = useCallback((_, { expandedState: newExpandedState }) => {
        setExpandedState(newExpandedState);
    }, []);
    return (React.createElement(TagListOuterContainer, { expandedState: expandedState, maxHeight: containerHeight, sx: outerContainerSx },
        React.createElement(TagListContainer, { ref: refContainer, sx: containerSx },
            items.map((item, i) => (React.createElement(Tag, { as: "li", key: typeof item === 'string' ? item : item.key, ref: (elem) => {
                    if (elem) {
                        // With as="li", the element is `HTMLLIElement`
                        refItems.current[i] = elem;
                    }
                }, ...rest, sx: [
                    expandedState === TagListExpandedState.COLLAPSED &&
                        typeof firstOverflowIndex !== 'undefined' &&
                        i >= firstOverflowIndex
                        ? {
                            visibility: 'hidden'
                        }
                        : {},
                    sx
                ] }, typeof item === 'string' ? item : item.node))),
            OverflowIndicator && (React.createElement(OverflowIndicator, { ref: refOverflow, hasBeenInitialized: hasBeenInitialized, expandedState: expandedState, hiddenItemsCount: typeof firstOverflowIndex === 'undefined'
                    ? 0
                    : items.length - firstOverflowIndex, top: overflowTop, left: overflowLeft, onToggle: onToggleOverflowIndicator })))));
};
export default TagList;
//# sourceMappingURL=TagList.js.map